import { Toast } from '@base-ui/react/toast';

/**
 * The one toast queue of the app. The platform hands it to `Toast.Provider`, so toasts added
 * from outside React (requests, thunks) and from components land in the same viewport.
 */
const toastManager = Toast.createToastManager();

export default toastManager;
